import { tokenAl } from './authApi';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

function yetkiliBaslik() {
  return {
    Authorization: 'Bearer ' + tokenAl(),
    'Content-Type': 'application/json'
  };
}

export async function takipListesiniGetir() {
  const response = await fetch(`${API_BASE}/api/watchlist`, { headers: yetkiliBaslik() });
  const veri = await response.json();

  if (!response.ok) {
    throw new Error(veri.error || 'Takip listesi alınamadı');
  }

  return veri.kodlar;
}

export async function takipListesineEkle(kod) {
  const response = await fetch(`${API_BASE}/api/watchlist`, {
    method: 'POST',
    headers: yetkiliBaslik(),
    body: JSON.stringify({ kod })
  });

  const veri = await response.json();

  if (!response.ok) {
    throw new Error(veri.error || 'Hisse eklenemedi');
  }

  return veri.kod;
}

export async function takipListesindenCikar(kod) {
  const response = await fetch(`${API_BASE}/api/watchlist/${encodeURIComponent(kod)}`, {
    method: 'DELETE',
    headers: yetkiliBaslik()
  });

  if (!response.ok && response.status !== 204) {
    const veri = await response.json().catch(() => ({}));
    throw new Error(veri.error || 'Hisse kaldırılamadı');
  }
}

export async function takipListesiniSirala(kodlar) {
  const response = await fetch(`${API_BASE}/api/watchlist/sirala`, {
    method: 'PUT',
    headers: yetkiliBaslik(),
    body: JSON.stringify({ kodlar })
  });

  const veri = await response.json();

  if (!response.ok) {
    throw new Error(veri.error || 'Sıralama kaydedilemedi');
  }

  return veri.kodlar;
}
